import { render } from "./PlayerModal.vue?vue&type=template&id=7ca561ce&scoped=true"
import script from "./PlayerModal.vue?vue&type=script&lang=js"
export * from "./PlayerModal.vue?vue&type=script&lang=js"

import "./PlayerModal.vue?vue&type=style&index=0&id=7ca561ce&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca561ce"]])

export default __exports__